<div *ngIf="state.visibility" class="message-bar flex flex-center">
  <div class="wrapper flex flex-space-between">
    <p>{{ state.message | transloco }}</p>
    <!-- If action is provided, show a link -->
    <!-- <a *ngIf="state.action" [routerLink]="state.action">Take action</a> -->
    <button (click)="hideBar()">X</button>
  </div>
</div>
